import React from 'react';
import { CnLayoutAside as UICnLayoutAside } from '@cainiaofe/cn-ui';
const CnLayoutAside = (props) => {
    const { children } = props || {};
    return <UICnLayoutAside>{children}</UICnLayoutAside>;
};
CnLayoutAside.displayName = 'CnLayoutAside';
CnLayoutAside.typeMark = 'Aside';
export default CnLayoutAside;
export { CnLayoutAside };
